module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"DeleteSuccess":"La succursale a bien été supprimée"}}')
  delete Component.options._Ctor
}
